module.exports = __webpack_public_path__ + "static/media/tennis_background2.4403ad9f.jpg";